<h3><atlas-icon [icon]="'rocket_launch'" [size]="'small'" alt="Password key"></atlas-icon>
  Email has been sent successfully</h3>

<div class="mos-u-spacer--padding-top-lg">
  <h4 class="mos-u-font-weight--medium">
    We sent an email to <span class="mos-u-color-text--primary-alt">{{ email }}</span> to make sure it’s you.
    Please check your email and enter your security code below.
  </h4>
</div>
<form [formGroup]="form" (keyup.enter)="onConfirm()">
  <div class="row mos-o-form-row">
    <div class="small-12 columns mos-o-form-input-field">
      <input [formControl]="form.get('security')" id="security-code-input" type="text" placeholder="Security Code">
    </div>
  </div>
  <div class="row mos-u-spacer--padding-bottom-md">
    <div class="small-12 medium-4 columns">
      <atlas-button (click)="onConfirm()" [disabled]="form.invalid">Confirm</atlas-button>
    </div>
    <div class="small-12 medium-1 columns mos-u-align-center--both">
      or
    </div>
    <div class="small-12 medium-7 columns">
      <atlas-button (click)="onActivate()">Activate Me Another
        Way</atlas-button>
    </div>
  </div>
</form>